import * as Yup from 'yup';

export const loginSchema = Yup.object({
    yourMail: Yup.string()
            .required("Email is required")
            .email("Invalid email address"),
    passWd: Yup.string()
            .required("password is required")
            .min(8,"Şifre 8 karakter uzunluğunda olmalıdır")
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
                ,
                "Şifre an az; bir büyük harf, bir küçük harf, bir numara ve özel karakter içermelidir"
            )

});